export default __webpack_public_path__ + "static/media/tree13.dc648588.png";